import { format } from "date-fns";

/**
 * Format period dates as "Jan 1, 2025 - Dec 31, 2025"
 */
export function formatPeriod(start: string, end: string): string {
  try {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const startFormatted = format(startDate, "MMM d, yyyy");
    const endFormatted = format(endDate, "MMM d, yyyy");
    return `${startFormatted} - ${endFormatted}`;
  } catch {
    return `${start} - ${end}`;
  }
}

/**
 * Format date as "MMM d, yyyy"
 */
export function formatDate(date: Date): string {
  try {
    return format(date, "MMM d, yyyy");
  } catch {
    return date.toString();
  }
}
